import styled from 'styled-components';
import { Color } from '../../../../enums';

export const Nav = styled.nav`
	border: 1px solid ${Color.border};
	display: flex;
	flex: 1;
	padding: 0;
`;

export const Ul = styled.ul`
	display: flex;
	flex: 1;
	flex-direction: column;
	margin-bottom: 0;
	margin-top: 0;
	padding: 0;
`;
